<template>
    <div class="stats-visits">
        <div class="toolbar">
            <el-form :inline="true">
                <el-form-item label="日期">
                    <el-date-picker
                        v-model="day"
                        type="date"
                        placeholder="选择日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                    />
                </el-form-item>
                <el-form-item label="房间">
                    <el-input
                        v-model="roomId"
                        type="text"
                        placeholder="room_id"
                        clearable
                        @keyup.enter="refresh"
                    />
                </el-form-item>
                <el-form-item label="播放">
                    <el-select v-model="playOk">
                        <el-option value="" label="全部" />
                        <el-option value="1" label="成功" />
                        <el-option value="0" label="失败" />
                    </el-select>
                </el-form-item>
                <el-form-item label="关键词">
                    <el-input
                        v-model="search"
                        type="text"
                        placeholder="sid/cid/平台"
                        clearable
                        @keyup.enter="refresh"
                    />
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="refresh">刷新</el-button>
            <el-button type="info" class="nav-button">
                <router-link to="/BigScreen" class="nav-button__link">数据大屏</router-link>
            </el-button>
            <el-button type="info" class="nav-button">
                <router-link to="/live-reply" class="nav-button__link">直播间回复</router-link>
            </el-button>
        </div>

        <div class="room-failure-float" v-loading="roomAcquireSummaryLoading">
            <div class="room-failure-float__title">当前查询时间范围房间号失败概览</div>
            <div class="room-failure-float__meta">总访问数 {{ roomAcquireSummary.totalVisits }}</div>
            <div class="room-failure-float__grid">
                <div class="room-failure-card room-failure-card--warn">
                    <div class="room-failure-card__label">房间号超时</div>
                    <div class="room-failure-card__value">{{ roomAcquireSummary.timeoutCount }}</div>
                    <div class="room-failure-card__ratio">{{ roomAcquireSummary.timeoutRatioText }}</div>
                </div>
                <div class="room-failure-card room-failure-card--danger">
                    <div class="room-failure-card__label">房间号失败</div>
                    <div class="room-failure-card__value">{{ roomAcquireSummary.errorCount }}</div>
                    <div class="room-failure-card__ratio">{{ roomAcquireSummary.errorRatioText }}</div>
                </div>
            </div>
            <div v-if="roomAcquireSummaryError" class="room-failure-float__error">
                {{ roomAcquireSummaryError }}
            </div>
        </div>

        <el-table :data="items">
            <el-table-column type="index" width="50" />
            <el-table-column type="expand">
                <template slot-scope="{ row }">
                    <el-row>
                        <el-col :span="10" :push="1">
                            {{ 'sid: ' + row.sid }}
                        </el-col>
                        <el-col :span="10" :push="1">
                            {{ 'cid: ' + row.cid }}
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="10" :push="1">
                            <div>文件加载耗时</div>
                            <el-table :data="row.extra_parsed.file_logs || []" border size="small">
                                <el-table-column prop="file_url" label="文件名" />
                                <el-table-column prop="duration" label="整体耗时 ms" />
                                <el-table-column prop="start" label="相对页面打开时间 ms" />
                                <el-table-column prop="transfer" label="传输字节数 byte" />
                            </el-table>
                        </el-col>
                        <el-col :span="10" :push="1">
                            <div>API 请求耗时</div>
                            <el-table :data="apiLogRows(row)" border size="small">
                                <el-table-column prop="url" label="请求链接" />
                                <el-table-column prop="duration" label="耗时" />
                                <el-table-column prop="status" label="状态" />
                                <el-table-column prop="phase" label="阶段" />
                            </el-table>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :push="1">
                            <el-descriptions title="webrtc">
                                <el-descriptions-item label="uid">
                                    {{ row.extra_parsed.extra?.agora_uid }}
                                </el-descriptions-item>
                                <el-descriptions-item label="agora 首帧">
                                    {{ row.extra_parsed.webrtc_info?.agora_first_frame_ms }}ms
                                </el-descriptions-item>
                                <el-descriptions-item label="webrtc 首次下行质量">
                                    {{ row.extra_parsed.webrtc_info?.webrtc_first_downlink }}
                                </el-descriptions-item>
                                <el-descriptions-item label="webrtc 首次上行质量">
                                    {{ row.extra_parsed.webrtc_info?.webrtc_first_uplink }}
                                </el-descriptions-item>
                                <el-descriptions-item label="webrtc 当前下行质量">
                                    {{ row.extra_parsed.webrtc_info?.webrtc_downlink }}
                                </el-descriptions-item>
                                <el-descriptions-item label="webrtc 当前上行质量">
                                    {{ row.extra_parsed.webrtc_info?.webrtc_uplink }}
                                </el-descriptions-item>
                                <el-descriptions-item label="RTT">
                                    {{ row.extra_parsed.webrtc_info?.webrtc_rtt_latest }}
                                </el-descriptions-item>
                                <el-descriptions-item label="下行码率 kbps">
                                    {{ row.extra_parsed.webrtc_info?.webrtc_downlink_bitrate_kbps }}
                                </el-descriptions-item>
                                <el-descriptions-item label="上行码率 kbps">
                                    {{ row.extra_parsed.webrtc_info?.webrtc_uplink_bitrate_kbps }}
                                </el-descriptions-item>
                            </el-descriptions>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="20" :push="1">
                            <div class="event-record-title">event_record 说明</div>
                            <el-table
                                :data="eventRecordRows(row)"
                                border
                                size="small"
                                class="event-record-table"
                                :row-style="({ row }) => row.done ? { color: 'green' } : { color: 'red' }"
                            >
                                <el-table-column type="index" label="序号" min-width="30" />
                                <el-table-column prop="eventName" label="事件名" min-width="180" />
                                <el-table-column prop="eventTime" label="发生时间" min-width="220" />
                                <el-table-column prop="description" label="说明" min-width="420" show-overflow-tooltip />
                            </el-table>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>

            <el-table-column
                prop="enter_ts"
                label="进入时间"
                width="180"
                :formatter="(row, column, cellValue) => fmtTs(cellValue)"
            />

            <el-table-column prop="room_id" label="房间" width="100">
                <template slot-scope="{ row }">
                    {{ row.room_id || '未开播' }}
                </template>
            </el-table-column>

            <el-table-column
                prop="extra_json"
                label="播放器"
                width="100"
                :filters="[
                    { text: '成功', value: true },
                    { text: '失败', value: false },
                ]"
                :filter-method="filterPlayerInit"
            >
                <template slot-scope="scope">
                    <span :class="['badge', playerInitOk(scope.row) ? 'ok' : 'fail']">
                        {{ playerInitOk(scope.row) ? '成功' : '失败' }}
                    </span>
                    <p v-if="scope.row.extra_parsed.extra?.subscribe_to_first_frame_ms">
                        订阅 => 首帧时长 {{ (scope.row.extra_parsed.extra?.subscribe_to_first_frame_ms / 1000) }}秒
                    </p>
                </template>
            </el-table-column>

            <el-table-column
                prop="play_ok"
                label="拉流"
                width="100"
                :filters="[
                    { text: '未知', value: null },
                    { text: '成功', value: 1 },
                    { text: '失败', value: 0 },
                ]"
                :filter-method="(value, row, column) => row[column.property] == value"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <div>
                        <span
                            v-if="scope.row.play_ok || scope.row.extra_json?.play_init != null"
                            :class="['badge', scope.row.play_ok || scope.row.extra_json?.play_init ? 'ok' : 'fail']"
                        >
                            {{ scope.row.play_ok || scope.row.extra_json?.play_init ? '成功' : '失败' }}
                        </span>
                        <span v-else class="badge na">未知</span>
                    </div>
                    <p v-if="scope.row.extra_json?.play_success_info || scope.row.extra_json?.play_fail_info">
                        {{ scope.row.extra_json?.play_success_info || scope.row.extra_json?.play_fail_info }}
                    </p>
                </template>
            </el-table-column>

            <el-table-column label="失败原因" min-width="160" show-overflow-tooltip>
                <template slot-scope="{ row }">
                    {{ failureReasonText(row) || '-' }}
                </template>
            </el-table-column>

            <el-table-column
                prop="extra_json"
                label="弹幕"
                width="100"
                :filters="[
                    { text: '成功', value: true },
                    { text: '失败', value: false },
                ]"
                :filter-method="filterDanmu"
            >
                <template slot-scope="scope">
                    <span v-if="scope.row.room_id" :class="['badge', scope.row.extra_json?.danmu ? 'ok' : 'fail']">
                        {{ scope.row.extra_json?.danmu ? '成功' : '失败' }}
                    </span>
                    <span v-else>-</span>
                </template>
            </el-table-column>

            <el-table-column
                prop="duration_ms"
                label="停留(s)"
                width="100"
                :formatter="formatDurationSeconds"
                :filters="[
                    { text: '0-1s', value: '1' },
                    { text: '1-2s', value: '2' },
                    { text: '2-3s', value: '3' },
                    { text: '3s+', value: '4' },
                    { text: '9s+', value: '5' },
                ]"
                :filter-method="filterDuration"
            />
            <el-table-column
                prop="referer"
                label="referer"
                width="100"
                :filters="[
                    { text: 'facebook', value: 'fb,facebook' },
                    { text: 'tiktok', value: 'tk,tiktok' },
                    { text: 'youtube', value: 'yt,youtube' },
                    { text: 'pin', value: 'pin' },
                    { text: 'ins', value: 'ins,instagram' },
                    { text: 'snapchat', value: 'snap,snapchat' },
                    { text: 'shopify', value: 'shopify_return' },
                    { text: '商城', value: 'ms_shop' },
                ]"
                :filter-method="filterReferer"
                :formatter="formatReferer"
                :show-overflow-tooltip="true"
            />
            <el-table-column
                prop="country"
                label="IP"
                width="180"
                :filters="[
                    { text: '美国', value: 'US' },
                    { text: '加拿大', value: 'CA' },
                    { text: '印度', value: 'IN' },
                ]"
                :filter-method="filterCountry"
            >
                <template slot-scope="scope">
                    <p>{{ scope.row.ip }}</p>
                    <p v-if="scope.row.country">{{ scope.row.country + ' ' + scope.row.region }}</p>
                </template>
            </el-table-column>

            <el-table-column
                prop="extra_json"
                label="命中服务器"
                width="180"
                :filters="[
                    { text: '弗吉尼亚', value: 'east' },
                    { text: '硅谷', value: 'west' },
                ]"
                :filter-method="filterEdge"
            >
                <template slot-scope="scope">
                    <p>{{ scope.row.extra_json.serverIp || scope.row.extra_json.server_ip || '-'}}</p>
                    <p>{{ scope.row.extra_json?.edgeId || '-'}} </p>
                    <p>{{ scope.row.extra_json?.server_id == 'us-west' ? '硅谷' : '弗吉尼亚' }}</p>
                </template>
            </el-table-column>

            

            <!-- <el-table-column prop="ua" label="网络" width="100">
                <template slot-scope="{ row }">
                    {{ row.ua | parseNetworkType }}
                </template>
            </el-table-column> -->

            <el-table-column
                prop="ua"
                label="终端设备"
                width="100"
                :filters="[
                    { text: 'Window11', value: 'X11' },
                    { text: 'iPhone', value: 'iPhone' },
                    { text: 'Android', value: 'Android' },
                    { text: 'Mac', value: 'Mac' },
                    { text: 'Window', value: 'Window' },
                ]"
                :filter-method="filterDevice"
                :formatter="formatDevice"
                :show-overflow-tooltip="true"
            />

            <el-table-column
                prop="ua"
                label="打开环境"
                width="150"
                :filters="uaOpenFilters"
                :filter-method="filterOpenEnvironment"
                show-overflow-tooltip
            >
                <template slot-scope="{ row }">
                    <span :class="['badge', uaOpenEnvironment(row.ua).badgeClass]">
                        {{ uaOpenEnvironment(row.ua).label }}
                    </span>
                    <p class="ua-env-detail">{{ uaOpenEnvironment(row.ua).detail }}</p>
                </template>
            </el-table-column>

            <el-table-column
                prop="ua"
                label="UA"
                :show-overflow-tooltip="true"
                :filters="[
                    { text: '爬虫数据', value: 0 },
                    { text: '非爬虫数据', value: 1 },
                ]"
                :filter-method="filterCrawler"
            />
        </el-table>

        <div class="pager">
            <button :disabled="offset === 0" @click="prevPage">上一页</button>
            <span>第 {{ page + 1 }} 页</span>
            <button :disabled="items.length < limit" @click="nextPage">下一页</button>
        </div>
    </div>
</template>

<script>
import {
    LIVE_STATS_PATHS,
    LEGACY_LIVE_STATS_PATHS,
    fetchLiveStatsJsonWithFallback,
} from '@/utils/live-stats-api'

const ROOM_API_TIMEOUT_RE = /(timeout|timed?\s*out|超时|deadline\s*exceeded|network\s*timeout|request\s*timeout|408|504|abort(?:ed)?)/i
const ROOM_API_ERROR_RE = /(error|fail(?:ed)?|失败|invalid|exception|unauthorized|forbidden|denied|接口返回错误|403|404|429|500|502|503)/i
const ROOM_API_CONTEXT_RE = /(room|房间|直播间|token|auth|鉴权|拉取房间号|api|接口)/i
const FIRST_FRAME_KEYS = ['video_first_frame']
const SUMMARY_BATCH_LIMIT = 1000
const SUMMARY_MAX_PAGES = 50
const IN_APP_UA_RULES = [
    { key: 'tiktok', label: 'TikTok 内置', pattern: /(tiktok|musical_ly|bytedancewebview|aweme|trill|com\.zhiliaoapp\.musically)/i },
    { key: 'instagram', label: 'Instagram 内置', pattern: /instagram/i },
    { key: 'messenger', label: 'Messenger 内置', pattern: /(FB_IAB\/Messenger|FBAN\/Messenger|MessengerForiOS|Messenger)/i },
    { key: 'facebook', label: 'Facebook 内置', pattern: /(FBAN|FBAV|FB_IAB|FB4A|FBIOS|FBForIPhone)/i },
    { key: 'pinterest', label: 'Pinterest 内置', pattern: /pinterest/i },
    { key: 'youtube', label: 'YouTube 内置', pattern: /youtube/i },
    { key: 'snapchat', label: 'Snapchat 内置', pattern: /snapchat/i },
    { key: 'x', label: 'X/Twitter 内置', pattern: /(twitter|x-twitter)/i },
    { key: 'whatsapp', label: 'WhatsApp 内置', pattern: /whatsapp/i },
    { key: 'wechat', label: '微信内置', pattern: /micromessenger/i },
    { key: 'line', label: 'LINE 内置', pattern: /\bline\//i },
    { key: 'weibo', label: '微博内置', pattern: /weibo/i },
    { key: 'telegram', label: 'Telegram 内置', pattern: /telegram/i },
    { key: 'qq', label: 'QQ 内置', pattern: /(QQ\/[\d.]|V1_AND_SQ_|MQQBrowser.+QQ\/)/i },
]
const UA_OPEN_FILTERS = [
    { text: '内置浏览器', value: 'in_app' },
    { text: '外部浏览器', value: 'external' },
    { text: '未知 WebView', value: 'webview' },
    { text: 'TikTok', value: 'tiktok' },
    { text: 'Facebook', value: 'facebook' },
    { text: 'Instagram', value: 'instagram' },
    { text: 'Messenger', value: 'messenger' },
    { text: 'Pinterest', value: 'pinterest' },
    { text: 'YouTube', value: 'youtube' },
    { text: 'Snapchat', value: 'snapchat' },
    { text: 'X/Twitter', value: 'x' },
    { text: '微信', value: 'wechat' },
    { text: 'LINE', value: 'line' },
    { text: 'WhatsApp', value: 'whatsapp' },
]

export default {
    name: 'StatsVisits',
    props: {
        base: { type: String, default: '' }
    },
    data() {
        return {
            day: '',
            from: '',
            to: '',
            roomId: '',
            playOk: '',
            search: '',
            limit: 200,
            offset: 0,
            items: [],
            loading: false,
            roomAcquireSummaryLoading: false,
            roomAcquireSummaryError: '',
            uaOpenFilters: UA_OPEN_FILTERS,
            roomAcquireSummary: {
                totalVisits: 0,
                timeoutCount: 0,
                timeoutRatioText: '0.0%',
                errorCount: 0,
                errorRatioText: '0.0%',
            },
        }
    },
    filters: {
        parseNetworkType(ua) {
            const raw = String(ua || '').toUpperCase()
            const match = raw.match(/(?:NETTYPE|CONNECTION)[/\- ]?([A-Z0-9+_]+)/)
            if (!match) return null
            const net = match[1].replace(/[^A-Z0-9+]/g, '')
            switch (true) {
                case /WIFI|WLAN/.test(net): return 'WiFi'
                case /5G/.test(net): return '5G'
                case /4G|LTE/.test(net): return '4G'
                case /3G/.test(net): return '3G'
                case /2G/.test(net): return '2G'
                case /ETHERNET|LAN/.test(net): return 'Ethernet'
                default: return net
            }
        }
    },
    watch: {
        '$route.query': {
            handler() {
                this.applyRouteQuery()
            },
            deep: true,
        },
    },
    computed: {
        page() {
            return Math.floor(this.offset / this.limit)
        },
        apiLogRows() {
            return (row) => this.normalizeApiLogs(row?.extra_parsed?.api_logs)
        }
    },
    methods: {
        toFiniteNumber(value) {
            const num = Number(value)
            return Number.isFinite(num) ? num : null
        },
        hasData(value) {
            return value != null && value !== ''
        },
        hasEventMark(record, key) {
            const value = record?.[key]
            if (value == null || value === '') return false
            const num = Number(value)
            return Number.isFinite(num) ? num > 0 : true
        },
        formatPercent(value) {
            const num = Number(value)
            if (!Number.isFinite(num)) return '0.0%'
            return `${(num * 100).toFixed(1)}%`
        },
        fmtTs(ts) {
            if (!ts) return ''
            const d = new Date(Number(ts))
            const pad = n => String(n).padStart(2, '0')
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
        },
        fmtTsMs(ts) {
            if (!ts) return '-'
            const d = new Date(Number(ts))
            if (Number.isNaN(d.getTime())) return '-'
            const pad = n => String(n).padStart(2, '0')
            const ms = String(d.getMilliseconds()).padStart(3, '0')
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${ms}`
        },
        parseExtraJsonSafe(raw) {
            if (!raw) return {}
            if (typeof raw === 'object') return raw
            try { return JSON.parse(raw) } catch (e) { return {} }
        },
        normalizeVisitRow(row) {
            return {
                ...row,
                extra_json: this.parseExtraJsonSafe(row.extra_json)
            }
        },
        normalizeApiLogs(apiLogs) {
            if (!apiLogs) return []

            const mapToRows = (m) =>
                Object.entries(m)
                    .filter(([, v]) => v && typeof v === 'object' && !Array.isArray(v))
                    .map(([name, v]) => ({ name, ...v }))

            const looksLikeSingleRow = (obj) =>
                obj &&
                typeof obj === 'object' &&
                !Array.isArray(obj) &&
                ('url' in obj || 'duration' in obj || 'status' in obj || 'phase' in obj || 'ok' in obj)

            if (typeof apiLogs === 'string') {
                try {
                    return this.normalizeApiLogs(JSON.parse(apiLogs))
                } catch {
                    return []
                }
            }

            if (Array.isArray(apiLogs)) {
                if (apiLogs.length === 0) return []
                const last = apiLogs[apiLogs.length - 1]
                if (last && typeof last === 'object' && !Array.isArray(last) && !looksLikeSingleRow(last)) {
                    return mapToRows(last)
                }
                return apiLogs
                    .map((item) => {
                        if (typeof item === 'string') {
                            try { return JSON.parse(item) } catch { return null }
                        }
                        return item
                    })
                    .filter(Boolean)
                    .flatMap((item) => looksLikeSingleRow(item) ? [{ name: item.name ?? null, ...item }] : mapToRows(item))
            }

            if (typeof apiLogs === 'object') {
                if (looksLikeSingleRow(apiLogs)) return [{ name: apiLogs.name ?? null, ...apiLogs }]
                return mapToRows(apiLogs)
            }

            return []
        },
        getEventRecordSource(row) {
            return row?.extra_parsed?.event_record
                || row?.extra_parsed?.extra?.event_record
                || row?.extra_json?.event_record
                || {}
        },
        getEventRecordMeta() {
            return [
                { key: 'token_fetch_start', label: 'token_fetch_start', description: '开始请求 RTC token' },
                { key: 'token_fetch_success', label: 'token_fetch_success', description: 'token 获取成功' },
                { key: 'token_fetch_fail', label: 'token_fetch_fail', description: 'token 获取失败' },
                { key: 'join_start', label: 'join_start', description: '开始调用 client.join()' },
                { key: 'join_success', label: 'join_success', description: '加入频道成功' },
                { key: 'join_fail', label: 'join_fail', description: '加入频道失败' },
                { key: 'subscribe_audio_start', label: 'subscribe_audio_start', description: '开始订阅音频' },
                { key: 'subscribe_audio_success', label: 'subscribe_audio_success', description: '订阅音频成功' },
                { key: 'subscribe_audio_fail', label: 'subscribe_audio_fail', description: '订阅音频失败' },
                { key: 'subscribe_video_start', label: 'subscribe_video_start', description: '开始订阅视频' },
                { key: 'subscribe_video_success', label: 'subscribe_video_success', description: '订阅视频成功' },
                { key: 'subscribe_video_fail', label: 'subscribe_video_fail', description: '订阅视频失败' },
                { key: 'audio_play_start', label: 'audio_play_start', description: '开始音频播放' },
                { key: 'audio_play_success', label: 'audio_play_success', description: '音频播放成功' },
                { key: 'audio_play_blocked', label: 'audio_play_blocked', description: '音频播放被拦截' },
                { key: 'audio_unlock', label: 'audio_unlock', description: '用户手动解锁音频播放' },
                { key: 'video_play_start', label: 'video_play_start', description: '开始处理视频播放' },
                { key: 'video_play_called', label: 'video_play_called', description: '调用 videoTrack.play(el)' },
                { key: 'video_first_frame', label: 'video_first_frame', description: '收到视频首帧' },
                { key: 'connection_connected', label: 'connection_connected', description: 'RTC 连接成功' },
                { key: 'connection_reconnecting', label: 'connection_reconnecting', description: 'RTC 重连中' },
                { key: 'connection_failed', label: 'connection_failed', description: 'RTC 连接失败' },
            ]
        },
        buildVisibleEventKeys(eventRecord = {}, keepPlaceholder = true) {
            const groups = {
                token_fetch: {
                    base: ['token_fetch_start'],
                    terminal: ['token_fetch_success', 'token_fetch_fail'],
                    priority: ['token_fetch_success', 'token_fetch_fail'],
                },
                join: {
                    base: ['join_start'],
                    terminal: ['join_success', 'join_fail'],
                    priority: ['join_success', 'join_fail'],
                },
                subscribe_audio: {
                    base: ['subscribe_audio_start'],
                    terminal: ['subscribe_audio_success', 'subscribe_audio_fail'],
                    priority: ['subscribe_audio_success', 'subscribe_audio_fail'],
                },
                subscribe_video: {
                    base: ['subscribe_video_start'],
                    terminal: ['subscribe_video_success', 'subscribe_video_fail'],
                    priority: ['subscribe_video_success', 'subscribe_video_fail'],
                },
                audio_play: {
                    base: ['audio_play_start'],
                    terminal: ['audio_play_success', 'audio_play_blocked', 'audio_unlock'],
                    priority: ['audio_unlock', 'audio_play_success', 'audio_play_blocked'],
                },
                connection: {
                    base: [],
                    terminal: ['connection_connected', 'connection_reconnecting', 'connection_failed'],
                    priority: ['connection_failed', 'connection_reconnecting', 'connection_connected'],
                },
            }

            const visible = new Set()
            const groupedKeys = new Set()

            Object.values(groups).forEach((group) => {
                const base = group.base || []
                const terminal = group.terminal || []
                const priority = group.priority || terminal

                base.concat(terminal).forEach((key) => groupedKeys.add(key))
                base.forEach((key) => visible.add(key))

                const hitTerminal = priority.find((key) => eventRecord?.[key] != null && eventRecord?.[key] !== '')
                if (hitTerminal) {
                    visible.add(hitTerminal)
                } else if (keepPlaceholder) {
                    terminal.forEach((key) => visible.add(key))
                }
            })

            this.getEventRecordMeta().forEach((item) => {
                if (!groupedKeys.has(item.key)) {
                    visible.add(item.key)
                }
            })

            return visible
        },
        eventRecordRows(row) {
            const source = this.getEventRecordSource(row)
            const visibleKeys = this.buildVisibleEventKeys(source, true)
            return this.getEventRecordMeta()
                .filter((item) => visibleKeys.has(item.key))
                .map((item, index) => ({
                    row_number: index + 1,
                    eventName: item.label,
                    eventTime: this.fmtTsMs(source[item.key]),
                    description: item.description,
                    done: source && source[item.key] != null && source[item.key] !== '',
                }))
        },
        getTodayString() {
            const d = new Date()
            const pad = n => String(n).padStart(2, '0')
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
        },
        parseRouteDateLike(raw) {
            if (raw == null || raw === '') return ''
            if (/^\d+$/.test(String(raw))) return String(Number(raw))
            const ts = Date.parse(String(raw))
            return Number.isFinite(ts) ? String(ts) : ''
        },
        applyRouteQuery() {
            const query = this.$route?.query || {}
            const hasRouteRoom = Object.prototype.hasOwnProperty.call(query, 'room_id')
            const hasRouteFrom = Object.prototype.hasOwnProperty.call(query, 'from')
            const hasRouteTo = Object.prototype.hasOwnProperty.call(query, 'to')

            if (!hasRouteRoom && !hasRouteFrom && !hasRouteTo) {
                const hadRouteState = this.from || this.to
                this.roomId = ''
                this.from = ''
                this.to = ''
                if (!this.day) this.day = this.getTodayString()
                if (hadRouteState) {
                    this.offset = 0
                    this.refresh()
                }
                return
            }

            this.roomId = hasRouteRoom && query.room_id ? String(query.room_id) : ''
            this.from = this.parseRouteDateLike(query.from)
            this.to = this.parseRouteDateLike(query.to)
            this.offset = 0

            if (this.from || this.to) {
                this.day = ''
            } else if (!this.day) {
                this.day = this.getTodayString()
            }

            this.refresh()
        },
        buildQuery(extra = {}) {
            const params = {
                limit: this.limit,
                offset: this.offset,
                ...((this.from || this.to)
                    ? {
                        ...(this.from ? { from: this.from } : {}),
                        ...(this.to ? { to: this.to } : {}),
                    }
                    : (this.day ? { day: this.day } : {})),
                ...(this.roomId ? { room_id: this.roomId } : {}),
                ...(this.playOk !== '' ? { play_ok: this.playOk } : {}),
                ...(this.search ? { search: this.search } : {}),
                ...extra,
            }
            const q = Object.entries(params)
                .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
                .join('&')
            return q ? `?${q}` : ''
        },
        buildRangeOnlyQuery(extra = {}) {
            const params = {
                limit: SUMMARY_BATCH_LIMIT,
                offset: 0,
                ...((this.from || this.to)
                    ? {
                        ...(this.from ? { from: this.from } : {}),
                        ...(this.to ? { to: this.to } : {}),
                    }
                    : (this.day ? { day: this.day } : {})),
                ...extra,
            }
            const q = Object.entries(params)
                .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
                .join('&')
            return q ? `?${q}` : ''
        },
        playerInitOk(row) {
            return !!(row?.extra_json?.player_init || row?.extra_json?.play_init)
        },
        filterPlayerInit(value, row, column) {
            const property = column.property
            return (!!row[property]?.play_init || !!row[property]?.player_init) === value
        },
        filterDanmu(value, row, column) {
            return !!row[column.property]?.danmu == value
        },
        getDurationMs(row) {
            const duration = this.toFiniteNumber(row?.duration_ms)
            if (duration != null) return duration
            const enterTs = this.toFiniteNumber(row?.enter_ts)
            const updatedAt = this.toFiniteNumber(row?.updated_at)
            if (enterTs == null || updatedAt == null) return 0
            return Math.max(0, updatedAt - enterTs)
        },
        formatDurationSeconds(row, column, cellValue) {
            return (this.getDurationMs({ ...row, [column.property]: cellValue }) / 1000).toFixed(2)
        },
        filterDuration(value, row, column) {
            const duration = this.getDurationMs({ ...row, [column.property]: row[column.property] })
            switch (value) {
                case '1': return duration < 1000
                case '2': return duration > 1000 && duration < 2000
                case '3': return duration > 2000 && duration < 3000
                case '4': return duration > 3000
                case '5': return duration > 9000
                default: return true
            }
        },
        filterCountry(value, row, column) {
            return row[column.property] === value
        },
        filterEdge(value, row, column) {
            return row[column.property]?.edgeId == value
        },
        filterReferer(value, row, column) {
            const referer = row[column.property] || ''
            return value.split(',').some((item) => referer.includes(`utm_source=${item}`) || referer.includes('shopify_return'))
        },
        formatReferer(row, column, cellValue) {
            const referer = String(cellValue || '')
            const platformList = ['tk', 'tiktok', 'pin', 'fb', 'facebook', 'yt', 'youtube', 'ins', 'instagram', 'shopify', 'snapchat','shop']
            const current = platformList.find((item) => referer.includes(`utm_source=${item}`) || referer.includes(`${item}_return`))
            const alias = {
                tk: 'tiktok',
                fb: 'facebook',
                yt: 'youtube',
                pin: 'pin',
                snap: 'snapchat',
                shop: '商城'
            }
            return alias[current] || current || ''
        },
        filterDevice(value, row, column) {
            const ua = String(row[column.property] || '')
            const deviceList = ['X11', 'iPhone', 'Android', 'Mac', 'Window']
            return deviceList.find((item) => ua.includes(item)) == value
        },
        formatDevice(row, column, cellValue) {
            const ua = String(cellValue || '')
            const deviceList = ['X11', 'iPhone', 'Android', 'Mac', 'Window']
            return deviceList.find((item) => ua.includes(item)) || ''
        },
        detectBrowserFromUA(ua) {
            if (/EdgA|EdgiOS|Edg\//i.test(ua)) return 'Edge'
            if (/SamsungBrowser/i.test(ua)) return 'Samsung Browser'
            if (/FxiOS|Firefox/i.test(ua)) return 'Firefox'
            if (/CriOS|Chrome\//i.test(ua)) return 'Chrome'
            if (/Safari/i.test(ua)) return 'Safari'
            return ''
        },
        isGenericAndroidWebView(ua) {
            return /;\s*wv\)/i.test(ua) || /\bwv\b/i.test(ua)
        },
        isGenericIOSWebView(ua) {
            return /(iPhone|iPad|iPod)/i.test(ua)
                && /AppleWebKit/i.test(ua)
                && /Mobile/i.test(ua)
                && !/(Safari|CriOS|FxiOS|EdgiOS|OPiOS)/i.test(ua)
        },
        uaOpenEnvironment(uaValue) {
            const ua = String(uaValue || '')
            if (!ua) {
                return {
                    key: 'unknown',
                    label: '未知',
                    detail: '无 UA',
                    inApp: null,
                    badgeClass: 'na',
                }
            }

            const matched = IN_APP_UA_RULES.find((rule) => rule.pattern.test(ua))
            if (matched) {
                return {
                    key: matched.key,
                    label: matched.label,
                    detail: '内置浏览器',
                    inApp: true,
                    badgeClass: 'warn',
                }
            }

            if (this.isGenericAndroidWebView(ua)) {
                return {
                    key: 'webview',
                    label: 'Android WebView',
                    detail: '疑似 App 内置',
                    inApp: true,
                    badgeClass: 'warn',
                }
            }

            if (this.isGenericIOSWebView(ua)) {
                return {
                    key: 'webview',
                    label: 'iOS WebView',
                    detail: '疑似 App 内置',
                    inApp: true,
                    badgeClass: 'warn',
                }
            }

            const browser = this.detectBrowserFromUA(ua)
            return {
                key: browser ? browser.toLowerCase().replace(/\s+/g, '_') : 'browser',
                label: browser || '外部浏览器',
                detail: '非内置浏览器',
                inApp: false,
                badgeClass: 'ok',
            }
        },
        filterOpenEnvironment(value, row, column) {
            const env = this.uaOpenEnvironment(row[column.property])
            if (value === 'in_app') return env.inApp === true
            if (value === 'external') return env.inApp === false
            return env.key === value
        },
        filterCrawler(value, row, column) {
            const ua = String(row[column.property] || '')
            return ua.includes('AdsBot-Google') == !value
        },
        detectRoomApiFailure(row) {
            const playText = [
                row?.extra_json?.play_fail_info,
                row?.extra_parsed?.play_metrics?.last_error_msg,
            ].filter(this.hasData).join(' | ').toLowerCase()
            const apiLogText = this.buildFailedApiLogText(row)
            const playHasContext = ROOM_API_CONTEXT_RE.test(playText)
            const apiHasContext = ROOM_API_CONTEXT_RE.test(apiLogText)

            const timeout = (playHasContext && ROOM_API_TIMEOUT_RE.test(playText))
                || (apiHasContext && ROOM_API_TIMEOUT_RE.test(apiLogText))
            const error = !timeout && (
                (playHasContext && ROOM_API_ERROR_RE.test(playText))
                || (apiHasContext && ROOM_API_ERROR_RE.test(apiLogText))
            )

            return { timeout, error }
        },
        buildFailedApiLogText(row) {
            const logs = this.normalizeApiLogs(row?.extra_parsed?.api_logs)
            return logs
                .map((log) => {
                    if (!log || typeof log !== 'object') return ''
                    const status = this.toFiniteNumber(log.status)
                    const rawText = [
                        log.name,
                        log.phase,
                        log.url,
                        log.method,
                        log.status,
                        log.error,
                        log.message,
                        log.reason,
                        log.summary,
                    ].filter(this.hasData).join(' ')
                    if (!rawText) return ''
                    const looksFailed = (status != null && status >= 400)
                        || log.ok === false
                        || ROOM_API_TIMEOUT_RE.test(rawText)
                        || ROOM_API_ERROR_RE.test(rawText)
                    return looksFailed ? rawText : ''
                })
                .filter(Boolean)
                .join(' | ')
                .toLowerCase()
        },
        hasFirstFrameMark(row) {
            const extra = row?.extra_parsed?.extra || {}
            const eventRecord = this.getEventRecordSource(row)
            return FIRST_FRAME_KEYS.some((key) => this.hasEventMark(eventRecord, key))
                || this.toFiniteNumber(row?.extra_parsed?.webrtc_info?.agora_first_frame_ms) > 0
                || this.toFiniteNumber(extra.subscribe_to_first_frame_ms) > 0
                || this.toFiniteNumber(extra.first_frame_after_ms) > 0
                || this.toFiniteNumber(row?.extra_parsed?.play_metrics?.first_frame_ms) > 0
        },
        getFailureDiagnosis(row) {
            const roomApi = this.detectRoomApiFailure(row)
            if (roomApi.timeout) {
                return { key: 'room_api_timeout', label: '房间号超时' }
            }
            if (roomApi.error) {
                return { key: 'room_api_error', label: '房间号失败' }
            }

            const eventRecord = this.getEventRecordSource(row)
            const hasTokenStart = this.hasEventMark(eventRecord, 'token_fetch_start')
            const hasTokenSuccess = this.hasEventMark(eventRecord, 'token_fetch_success')
            const hasJoinStart = this.hasEventMark(eventRecord, 'join_start')
            const hasJoinSuccess = this.hasEventMark(eventRecord, 'join_success')
            const hasAudioStart = this.hasEventMark(eventRecord, 'subscribe_audio_start')
            const hasAudioSuccess = this.hasEventMark(eventRecord, 'subscribe_audio_success')
            const hasVideoStart = this.hasEventMark(eventRecord, 'subscribe_video_start')
            const hasVideoSuccess = this.hasEventMark(eventRecord, 'subscribe_video_success')
            const hasConnectionConnected = this.hasEventMark(eventRecord, 'connection_connected')
            const hasVideoPlaybackStage = hasVideoSuccess
                || this.hasEventMark(eventRecord, 'video_play_start')
                || this.hasEventMark(eventRecord, 'video_play_called')
                || this.hasEventMark(eventRecord, 'anchor_published_video')

            if (hasTokenStart && !hasTokenSuccess) {
                return { key: 'token_not_success', label: 'Token 未成功' }
            }
            if (hasTokenSuccess && !hasJoinSuccess) {
                return {
                    key: 'join_incomplete',
                    label: hasJoinStart ? '未完成加入频道' : '未完成加入频道'
                }
            }
            if (hasJoinSuccess && !hasAudioSuccess) {
                return {
                    key: hasAudioStart ? 'subscribe_audio_failed' : 'subscribe_audio_missing',
                    label: hasAudioStart ? '订阅音频失败' : '未订阅音频'
                }
            }
            if (hasJoinSuccess && !hasVideoSuccess) {
                return {
                    key: hasVideoStart ? 'subscribe_video_failed' : 'subscribe_video_missing',
                    label: hasVideoStart ? '订阅视频失败' : '未订阅视频'
                }
            }
            if (hasAudioSuccess && hasVideoSuccess && !hasConnectionConnected) {
                return { key: 'rtc_not_connected', label: 'RTC 未连接成功' }
            }
            if (this.hasEventMark(eventRecord, 'audio_play_blocked')) {
                return { key: 'audio_play_blocked', label: '音频播放被拦截' }
            }
            if (hasVideoPlaybackStage && !this.hasFirstFrameMark(row)) {
                return { key: 'missing_first_frame', label: '未收到视频首帧' }
            }
            if (row?.play_ok === 0) {
                return { key: 'play_fail_other', label: '其他拉流失败' }
            }
            return { key: '', label: '' }
        },
        failureReasonText(row) {
            return this.getFailureDiagnosis(row).label
        },
        async fetchRoomAcquireSummaryByVisits() {
            this.roomAcquireSummaryLoading = true
            this.roomAcquireSummaryError = ''
            try {
                const aggregated = new Map()
                let pageCount = 0
                let offset = 0

                while (pageCount < SUMMARY_MAX_PAGES) {
                    const data = await fetchLiveStatsJsonWithFallback(
                        this.base,
                        LIVE_STATS_PATHS.visits,
                        LEGACY_LIVE_STATS_PATHS.visits,
                        this.buildRangeOnlyQuery({ limit: SUMMARY_BATCH_LIMIT, offset })
                    )
                    const batch = Array.isArray(data.items) ? data.items.map((item) => this.normalizeVisitRow(item)) : []

                    batch.forEach((row) => {
                        if (row?.sid != null) {
                            aggregated.set(String(row.sid), row)
                        }
                    })

                    if (batch.length < SUMMARY_BATCH_LIMIT) break
                    offset += SUMMARY_BATCH_LIMIT
                    pageCount += 1
                }

                let timeoutCount = 0
                let errorCount = 0
                Array.from(aggregated.values()).forEach((row) => {
                    if (String(row?.room_id || '').trim()) return
                    const result = this.detectRoomApiFailure(row)
                    if (result.timeout) timeoutCount += 1
                    else if (result.error) errorCount += 1
                })

                const totalVisits = aggregated.size
                this.roomAcquireSummary = {
                    totalVisits,
                    timeoutCount,
                    timeoutRatioText: this.formatPercent(totalVisits > 0 ? timeoutCount / totalVisits : 0),
                    errorCount,
                    errorRatioText: this.formatPercent(totalVisits > 0 ? errorCount / totalVisits : 0),
                }
            } catch (error) {
                this.roomAcquireSummaryError = error?.message || '房间号失败概览加载失败'
                this.roomAcquireSummary = {
                    totalVisits: 0,
                    timeoutCount: 0,
                    timeoutRatioText: '0.0%',
                    errorCount: 0,
                    errorRatioText: '0.0%',
                }
            } finally {
                this.roomAcquireSummaryLoading = false
            }
        },
        async refresh() {
            this.loading = true
            try {
                const [visitsData] = await Promise.all([
                    fetchLiveStatsJsonWithFallback(
                        this.base,
                        LIVE_STATS_PATHS.visits,
                        LEGACY_LIVE_STATS_PATHS.visits,
                        this.buildQuery()
                    ),
                    this.fetchRoomAcquireSummaryByVisits(),
                ])
                this.items = (visitsData.items || []).map((item) => this.normalizeVisitRow(item))
            } finally {
                this.loading = false
            }
        },
        prevPage() {
            if (this.offset === 0) return
            this.offset = Math.max(0, this.offset - this.limit)
            this.refresh()
        },
        nextPage() {
            if (this.items.length < this.limit) return
            this.offset += this.limit
            this.refresh()
        },
    },
    mounted() {
        this.day = this.getTodayString()
        this.applyRouteQuery()
        if (!this.$route?.query || Object.keys(this.$route.query).length === 0) {
            this.refresh()
        }
    }
}
</script>

<style scoped>
.page-actions {
    margin-top: 20px;
    margin-right: 20px;
}

.user-entry {
    font-size: 30px;
    color: black;
    float: right;
}

.toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: flex-start;
    margin-bottom: 12px;
}

.nav-button {
    background: #000;
}

.nav-button__link {
    color: #fff;
}

.room-failure-float {
    position: sticky;
    top: 12px;
    z-index: 20;
    margin: 0 0 12px auto;
    width: min(420px, 100%);
    padding: 16px;
    border-radius: 16px;
    background: rgba(15, 23, 42, 0.92);
    color: #fff;
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.22);
    backdrop-filter: blur(10px);
}

.room-failure-float__title {
    font-size: 15px;
    font-weight: 600;
}

.room-failure-float__meta {
    margin-top: 6px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.75);
}

.room-failure-float__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 14px;
}

.room-failure-card {
    border-radius: 12px;
    padding: 12px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.room-failure-card--warn {
    background: rgba(245, 158, 11, 0.14);
    border-color: rgba(245, 158, 11, 0.28);
}

.room-failure-card--danger {
    background: rgba(239, 68, 68, 0.14);
    border-color: rgba(239, 68, 68, 0.28);
}

.room-failure-card__label {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.78);
}

.room-failure-card__value {
    margin-top: 8px;
    font-size: 28px;
    line-height: 1;
    font-weight: 700;
}

.room-failure-card__ratio {
    margin-top: 6px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.88);
}

.room-failure-float__error {
    margin-top: 10px;
    font-size: 12px;
    color: #fecaca;
}

.pager {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-top: 16px;
}

.badge {
    padding: 2px 6px;
    border-radius: 10px;
    font-size: 12px;
}

.badge.ok {
    background: #e6ffed;
    color: #007a2f;
    border: 1px solid #b7f5c6;
}

.badge.fail {
    background: #ffecec;
    color: #b00020;
    border: 1px solid #ffc7c7;
}

.badge.warn {
    background: #fff7e6;
    color: #ad6800;
    border: 1px solid #ffd591;
}

.badge.na {
    background: #eee;
    color: #555;
    border: 1px solid #ddd;
}

.ua-env-detail {
    margin: 4px 0 0;
    color: #6b7280;
    font-size: 12px;
}

.event-record-title {
    margin: 12px 0 8px;
    font-size: 12px;
    font-weight: 600;
    color: #333;
}

.event-record-table {
    font-size: 12px;
}

.event-record-table ::v-deep .el-table__cell {
    font-size: 12px;
}
</style>
